"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var USER_SERVICE_URL = 'https://cis.mpianalytics.com';
var USER_SERVICE_PATH = '/api/v1/identify';
var _default = exports["default"] = {
  cisBaseUrl: USER_SERVICE_URL,
  cisBasePath: USER_SERVICE_PATH
};